import NotFound from './not_found';

export default NotFound;
